export default {
    email_address: [
        { required: true, message: window.i18n.__('Veuillez saisir un email'), trigger: 'blur' },
        { type: 'email', message: window.i18n.__('Veuillez saisir une adresse email valide'), trigger: 'blur' },
    ],
    email_password: [
        { required: true, message: window.i18n.__('Veuillez saisir un mot de passe'), trigger: 'blur' },
    ]
}